import React from "react";
import { injectIntl } from "react-intl";
import { PageHeaderWrapper } from "./partial";
import Logo from "../logo";
import PropTypes from "prop-types";

const PageHeader = ({ url, intl, logoUrl, logoAlt }) => (
  <PageHeaderWrapper>
    <Logo url={url} logoUrl={logoUrl} logoAlt={logoAlt} />
  </PageHeaderWrapper>
);

PageHeader.propTypes = {
  /**
   * Url del enlace
   */
  url: PropTypes.string,
  /**
   ** Url del logo
   **/
  logoUrl: PropTypes.string,
  /**
   ** Texto alternativo del logo
   **/
  logoAlt: PropTypes.string,
};

export default injectIntl(PageHeader);
